(ns frontend.view.components.timeline.entry.person-update
  (:require
   [frontend.view.components.timeline.entry.declaration :as te]
   [frontend.view.components.timeline.entry.default-item :as default]
   [frontend.view.components.timeline.entry.utils :as utils]
   [common.localization :as loc]
   [common.entity :as zap-entity]
   [frontend.state.current-session :as session]
   [common.schema.registry :as registry]))

(defn title-generator
  [entry]
  (let [op (-> entry
               :audit/op)
        person (->> entry
                    :audit/target
                    (get @session/entities))
        p-name (str (:person/first-name person) " " (:person/last-name person))]
    (loc/tr op [p-name])))

(defn body-generator
  [entry]
  (let [changes (:audit/target-changes entry)
        tenant-schema @session/tenant-schema]
    (for [[f-key f-val] changes]
      (when-not (some #{f-key}
                      [:common/updated-by :common/updated-on
                       :person/fullcontact-person :person/clearbit-person])
        (let [f-set (:set f-val)
              f-add (:add f-val)]
          ^{:key (str "timeline-op-person-update" (:db/id entry) f-key)}
          [:div
           (case f-key
             :person/tags (utils/arrow-message
                           (let [fs (registry/get-field-schema tenant-schema f-key)]
                             (loc/field-name f-key fs))
                           (utils/tags f-val))
             :common/created-on (utils/date-field-update f-key f-set)
             :db/id nil
             (utils/arrow-message (let [fs (registry/get-field-schema tenant-schema
                                                                      f-key)]
                                    (loc/field-name f-key fs))
                                  (zap-entity/display-string f-set)))])))))

(defmethod te/timeline-entry-view :op.person/update
  [{entry :entry accounts :accounts}]
  [default/timeline-item-view entry title-generator body-generator default/timestamp-generator])
